<template>
  <div>
     <v-select v-model="mailbox" :options="mailboxes_collection" placeholder="Select Mailbox"/>
  </div>
</template>
<script>
import { collectionsMixins } from '@/mixins/collectionsMixins'
export default {
  name: 'MailboxSelector',
  mixins: [collectionsMixins],
  data () {
    return {
      mailboxes_collection: [],
      mailbox: {}
    }
  },
  created () {
    this.mailboxesCollection()
  },
  watch: {
    mailbox () {
      this.$emit('selected', {id: this.mailbox.value, name: this.mailbox.label})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/selectors/MailboxSelector.vue